import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import PrivateRoute from '../utils/PrivateRoute';
import CallbackPage from './CallbackPage';
import LoginPage from '../containers/LoginPage';
import RouteMaker from '../utils/RouteMaker';

const Routes = (props) => {

  const { role, allowedRoutes } = props; 
  return (
    
      <Switch>        
        {/* To redirect authed to /home and not authed to /login when path is empty */}
        <Route exact path="/" render={() => ( role !== null ? (<Redirect to="/home" /> ) : (<Redirect to="/login" />))} />
        {/* Used for oidc callback redirecting */}
        <Route exact path="/callback" component={CallbackPage} />
        { /* If not authorized redirect for login page. Also prevents logged in user for going to /login */}
        <PrivateRoute exact path="/login" authed={role === null} component={LoginPage} />
        
        {role === null ? (
          <Redirect to="/login"/> 
        ) : ( 
          <RouteMaker allowedRoutesList={allowedRoutes}/> )}
        
      </Switch>
  );
};




export default Routes;



// WEBPACK FOOTER //
// ./src/containers/Routes.js